import React, {h, Component} from 'preact';


export default class BuyFinancingStep extends Component {

    choosePreApproved(financing) {
        $.get('update-buyrequest-json', {
            financing,
            buyerStage: this.props.parent.state.buyerStage,
            propertyType: this.props.parent.state.homeType,
            priceRange: this.props.parent.state.lowRange + '-' + this.props.parent.state.highRange
        });
        this.props.parent.setState({financing, currentStep: 'BUY_CONTACT_FORM'});
    }

    componentDidMount() {
        trackEvent('Flow', 'BuyRequest', 'buyStep4').withGA().withOptimizely();
    }

    render() {
        return <div className="flow-step">
            <div className="flow-step-text hidden-xs">
                <img className ="icon-desktop" src={global.imageBaseUrl + '/buysell/svg/buy-faster.svg'} />
                <div>UpNest partner agents help home buyers find their home in 29 days on average.</div>
            </div>

            <div className="flow-step-header-text">
                <strong>Do you want to get a loan pre-approval letter to help with your home search?</strong>
            </div>

            <div className="option-div">
                <div id="buyer-stage-div">
                    <div className="choice-button buyer-stage-button"  onClick={() => this.choosePreApproved('pre-approved')}>
                        <img src={global.imageBaseUrl + '/buysell/svg/pre-approved.svg'}/>
                        <div className="button-text" style={{overflow: 'hidden'}}>
                            <span>Yes</span>
                        </div>
                    </div>
                    <div className="choice-button buyer-stage-button"  onClick={() => this.choosePreApproved('not-pre-approved')}>
                        <img src={global.imageBaseUrl + '/buysell/svg/not-pre-approved.svg'}/>
                        <div className="button-text" style={{overflow: 'hidden'}}>
                            <span>No</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flow-spacer"/>

            <div className="bottom-banner">
                <div className="status-normal">
                    <div className="title"><img src={global.imageBaseUrl + '/buysell/svg/buy-faster.svg'}/> Buy Faster</div>
                    <div className="subtitle subtitle-large">UpNest partner agents help home buyers find their home in 29 days on average.</div>
                </div>
                <div className="subtitle subtitle subtitle-small">
                    UpNest partner agents help home buyers find their home in 29 days on average.
                </div>
            </div>
        </div>;
    }
}
